<template>
    <div name="home" class="home" v-if="step === 0">
        <img style="width: 100%;" :src="logoImage" />
        <img style="width: 100%;" src="../../assets/showcase/xi/home/inbody.png" @click="goInbody"/>
        <img style="width: 100%;" src="../../assets/showcase/xi/home/department1.png" @click="departmentClick"  />
        <div class="wrapper">
            <img style="width: 100%;position: relative;" src="../../assets/showcase/xi/home/department2.png" @click="departmentClick" />
            <div class="plus-button" @click="plusClick"></div>
        </div>
        <img style="width: 100%;" src="../../assets/showcase/preview/home/concierge_banner.png" @click="goConcierge"/>
        <img style="width: 100%; margin-top: -10px;" src="../../assets/showcase/xi/home/4.png" />
        <img style="width: 100%;" src="../../assets/showcase/xi/home/5.png" @click="goSearch"/>
        <img style="width: 100%;" src="../../assets/showcase/xi/home/7.png" />
        <div class="bottom" style="position: relative;">
            <img style="width: 100%;"  src="../../assets/showcase/xi/home/8.png" />
            <div class="button1" @click="goFamily">

            </div>
             <div class="button2" @click="goPayment">

            </div>
             <div class="button3" @click="goConcierge">

            </div>
             <div class="button4" @click="goConcierge">

            </div>
        </div>
    </div>
    <div v-else class="home">
        <div class="distribute-button-area">
            <img class="back-image" src="../../assets/showcase/preview/department/1.png" >
            <div class="header-back-button" @click="stepChange(0)"></div>
            <div class="header-search-button" @click="goSearch"></div>
        </div>
        
        <div class="bottom" v-if="tab === 0">
            <img class="image" src="../../assets/showcase/preview/department/2_1.png" @click="tabChange(1)">
            <img class="image" src="../../assets/showcase/preview/department/3_1.png"  @click="departmentClick">
            <img class="image" src="../../assets/showcase/preview/department/4.png"  @click="departmentClick">
        </div>
        <div class="bottom" v-else>
            <img class="image" src="../../assets/showcase/preview/department/2_2.png" @click="tabChange(0)">
            <img class="image" src="../../assets/showcase/preview/department/3_2.png"  @click="departmentClick">
            <img class="image" src="../../assets/showcase/preview/department/4.png"  @click="departmentClick">
        </div>        
    </div>
</template>

<script>
export default {
    data: function()
    {
        return {
            step: 0,
            tab: 0,
            logoImages: {
                xi: require('../../assets/showcase/xi/home/1.png'),
                soldoc: require('../../assets/showcase/soldoc/1.png'), // TODO: kocom 로고로 변경
                seoulone: require('../../assets/showcase/seoulone/1.png'),
                lynn: require('../../assets/showcase/lynn/1.png')
            }
        }
    },
    computed: {
        showcase: function() {
            return this.$route.params.showcase
        },
        logoImage: function() {
            return this.logoImages[this.showcase] || this.logoImages.xi
        }
    },
    methods: {
        departmentClick: function() {
            this.$emit('goBooking');
            // this.$router.push({name: 'menu'});
        },
        plusClick: function() {
            this.step = 1;
            // alert("플러스 버튼 클릭")
            // this.$router.push({name: 'preview'});
        },
        goInbody: function()
        {
            this.$emit('goInbody')
        },
        goSearch: function()
        {
            this.$emit('goSearchTab')
        },
        reset: function()
        {
            this.$emit('resetCount')
        },
        stepChange: function(step)
        {
            this.step = step;
            this.reset();
        },
        tabChange: function(tab)
        {
            this.tab = tab;
            this.reset();
        },
        goConcierge: function()
        {
            this.$emit('goConcierge')
        },
        goPayment: function()
        {
            this.$emit('goPayment')
        },
        goFamily: function()
        {
            this.$emit('goFamily')
        }
    }
}
</script>

<style scoped>
    .plus-button {
        aspect-ratio: 1;
        height: 90%;
        top: 0;
        right: 2vw;
        position: absolute;
        z-index: 1;
    }   
    .wrapper {
        position: relative;
        width: 100%;
    }
    .bottom {
        margin-bottom: calc(100vw * 120 / 375);
        background: #FFF;
        width: 100%;
    }
    .fix {
        position: fixed;
        bottom: 0;
        position: fixed; 
        width: calc(80%);
        left: 50%;
        transform: translate(-50%, 0);
    }
    .home {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        background: #FFF;
        width: 100%;
        position: relative;

    }
    .image {
        width: 100%;
    }

    .button1{
        width: 25%;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
    }
    .button2 {
        width: 25%;
        position: absolute;
        height: 100%;
        top: 0;
        left: 25%;
    }
    .button3 {
        width: 22%;

        position: absolute;
        height: 100%;
        top: 0;
        left: 50%;
    }
    .button4 {
        width: 28%;

        position: absolute;
        height: 100%;
        top: 0;

        left: 72%;
    }
    .distribute-button-area {
        display: flex;
        position: relative;
        width: 100%;
        aspect-ratio: 7;
    }
    .back-image {
        position: absolute;
        width: 100%;
    }
    .header-back-button {
        width: 12%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
    }
    .header-search-button {
        width: 82%;
        height: 100%;
        top: 0;
        left: 12%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Home.vue